import React from 'react';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const ScoringNavArrows = ({
  rubrics,
  rubricIndex,
  goToNextQuestion,
  goToPreviousQuestion,
  hasNextQuestion,
  hasPreviousQuestion,
  gotToPreviousScoringSection,
  gotToNextScoringSection,
  skipRubrics,
}) => {
  const shouldGoToNextQuestion =
    Array.isArray(rubrics) &&
    hasNextQuestion &&
    (skipRubrics || rubricIndex >= rubrics.length - 1);
  const shouldGoToPreviousQuestion =
    hasPreviousQuestion && (skipRubrics || rubricIndex <= 0);

  const isNextDisabled = () => {
    if (!hasNextQuestion && Array.isArray(rubrics)) {
      return (
        skipRubrics ||
        rubrics.length === 0 ||
        rubricIndex === rubrics.length - 1
      );
    }
    return false;
  };

  return (
    <div
      className="absolute mobile:fixed z-10 rounded-full border border-solid border-gray-300
     p-3 flex right-8 bottom-8 mobile:bottom-24 bg-opacity-75 bg-white"
    >
      <ButtonWithIcon
        data-test-rubric-nav-prev
        isIcon
        isPrimary
        aria-label="Previous"
        tabIndex="0"
        disabled={!hasPreviousQuestion && rubricIndex === 0}
        icon="navigate_back"
        className="mr-8"
        iconClassName="text-white"
        onClick={() => {
          if (shouldGoToPreviousQuestion) {
            return goToPreviousQuestion(!skipRubrics);
          }
          gotToPreviousScoringSection();
        }}
      />

      <ButtonWithIcon
        data-test-rubric-nav-next
        isIcon
        isPrimary
        aria-label="Next"
        tabIndex="0"
        disabled={isNextDisabled()}
        icon="navigate_next"
        iconClassName="text-white"
        onClick={() => {
          if (shouldGoToNextQuestion) {
            return goToNextQuestion();
          }
          gotToNextScoringSection();
        }}
      />
    </div>
  );
};

ScoringNavArrows.defaultProps = {
  goToNextQuestion: () => {},
  goToPreviousQuestion: () => {},
  gotToPreviousScoringSection: () => {},
  gotToNextScoringSection: () => {},
  tabsActionCallback: () => {},
  rubrics: [],
  rubricIndex: 0,
  hasNextQuestion: true,
  hasPreviousQuestion: true,
};

export default ScoringNavArrows;
